interface TeamFlagProps {
  team: 'USA' | 'EU';
  size?: 'small' | 'medium';
}

const FLAG_CONFIGS = {
  USA: {
    src: 'https://flagcdn.com/us.svg',
    alt: 'US',
  },
  EU: {
    src: 'https://flagcdn.com/eu.svg',
    alt: 'EU',
  },
} as const;

export function TeamFlag({ team, size = 'medium' }: TeamFlagProps) {
  const config = FLAG_CONFIGS[team];
  const dimensions = size === 'small' ? { width: '20px', height: '15px' } : { width: '24px', height: '18px' };

  return (
    <img
      src={config.src}
      alt={config.alt}
      style={{
        ...dimensions,
        imageRendering: 'crisp-edges',
        marginLeft: '8px',
      }}
    />
  );
}
